(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["text"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('text-block-collapse')) {
    class TextBlockCollapse extends HTMLElement {
      connectedCallback() {
        this.#content = this.querySelector('.text-block-collapse__content');
        this.#button = this.querySelector('.text-block-collapse__toggle');

        if (!this.#content || !this.#button) return;

        this.#button.addEventListener('click', this.#toggle);
        this.#updateButtonVisibility();

        if ('ResizeObserver' in window) {
          this.#resizeObserver = new ResizeObserver(() => this.#updateButtonVisibility());
          this.#resizeObserver.observe(this.#content);
        }
      }

      disconnectedCallback() {
        this.#button?.removeEventListener('click', this.#toggle);
        this.#resizeObserver?.disconnect();
      }

      #content;
      #button;
      #resizeObserver;

      #toggle = (event) => {
        event.preventDefault();

        const expanded = this.dataset.expanded === 'true';
        this.dataset.expanded = expanded ? 'false' : 'true';
        this.#button.setAttribute('aria-expanded', expanded ? 'false' : 'true');
        this.#updateButtonVisibility();

        if (expanded) {
          const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches
            ? 'instant'
            : 'smooth';
          requestAnimationFrame(() => {
            this.scrollIntoView({ behavior, block: 'start' });
          });
        }
      };

      #updateButtonVisibility() {
        if (!this.#content || !this.#button) return;

        if (this.dataset.expanded === 'true') {
          this.#button.hidden = false;
          return;
        }

        this.#button.hidden = this.#content.scrollHeight <= this.#content.clientHeight + 1;
      }
    }

    customElements.define('text-block-collapse', TextBlockCollapse);
  }
  } catch(e) { console.error(e); }
})();

})();
